import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import AuthService from '../../../business-api/AuthService'

import {
    GridContainerReport,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ImgLogoReport,
} from '../../../business-components/Img/Img'

const EstudoReportPageCapa = ({ variaveisGlobais, values, vars, conteudo }) => {

    const alinhamentoLogo =
        vars.jsonConfiguracao && vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].alinhamentoLogoCapaRelatorio
            ?
                vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].alinhamentoLogoCapaRelatorio
            :
                'left'

    return (
        <div
            className={
                values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                    ?
                        "paginaRetrato"
                    :
                        "paginaPaisagem"
            }
        >
            <div
                className={
                    values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                        ?
                            "cabecalhoCapaRetrato"
                        :
                            "cabecalhoCapaPaisagem"
                }
            >
                <GridContainerReport>
                    <GridItem12
                        align={alinhamentoLogo}
                    >
                        {AuthService.obterLogo(variaveisGlobais) &&
                        vars.jsonConfiguracao &&
                        !vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].naoExibirLogoCapaRelatorio
                            ?
                                <ImgLogoReport
                                    variaveisGlobais={variaveisGlobais}
                                    className="ml-4 mt-1"
                                    src={AuthService.obterLogo(variaveisGlobais)}
                                />
                            :
                                ''
                        }
                    </GridItem12>
                </GridContainerReport>
            </div>

            <div
                className={
                    values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                        ?
                            "bodyCapaRetrato"
                        :
                            "bodyCapaPaisagem"
                }
            >
                <GridContainerReport>
                    <GridItem12>
                        {conteudo}
                    </GridItem12>
                </GridContainerReport>
            </div>

            <div
                className={
                    values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                        ?
                            "rodapeCapaRetrato"
                        :
                            "rodapeCapaPaisagem"
                }
            >
                <GridContainerReport>
                    <GridItem12 />
                </GridContainerReport>
            </div>
        </div>
    )
}

export default EstudoReportPageCapa